import styles from "./FileUploader.module.css";

import React, { useEffect } from "react";
import { useDropzone } from "react-dropzone";

const FileUploader: React.FC<{ onSubmit: (file: File) => any }> = ({
  onSubmit,
}) => {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();

  useEffect(() => {
    if (acceptedFiles.length) {
      onSubmit(acceptedFiles[0]);
    }
  }, [acceptedFiles]);

  return (
    <section className={styles.container}>
      <div {...getRootProps({ className: styles.dropzone })}>
        <input {...getInputProps()} />
        <p>Drag 'n' drop some files here, or click to select files</p>
      </div>
    </section>
  );
};

export default FileUploader;
